import { QueryCache, QueryClient } from '@tanstack/react-query'
import type { AxiosError } from 'axios'
import { enqueueSnackbar } from 'notistack'

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query.meta?.getErrorMessage) {
        const { getErrorMessage } = query.meta as {
          getErrorMessage: (error: Error) => string
        }
        enqueueSnackbar(getErrorMessage(error), { variant: 'error' })
      }
    },
  }),
  defaultOptions: {
    queries: {
      retry: (retryCount, err) => {
        const error = err as AxiosError
        const statusCode = error.response?.status

        return retryCount === 0 && statusCode !== 401 && statusCode !== 403
      },
      refetchOnWindowFocus: false,
      staleTime: 60 * 1000,
    },
  },
})
